module.exports = __webpack_public_path__ + "static/media/BRHMA KUMARI INTERNATIONAL HEADQUARTERS BIG AND SMALL.c21f4c9e.png";